export default "__VITE_PUBLIC_ASSET__10e1346d__"